import { AfterViewInit, Component, OnInit } from '@angular/core';
import { PageLayoutBaseComponent } from '../page-layout-base.component';
import { AppService } from 'src/app/app.service';
import { HeroImageComponent } from '../../hero-image/hero-image.component';
import { AdobePdfService } from 'src/app/services/adobe-pdf.service';
import { PdfViewerComponent } from '../../pdf-viewer/pdf-viewer.component';
import { PDFDocuments } from 'src/app/types/PDFDocuments';
import { CallOutBoxComponent } from '../../call-out-box/call-out-box.component';

@Component({
  selector: 'app-project-overview',
  imports: [HeroImageComponent, PdfViewerComponent, CallOutBoxComponent],
  templateUrl: './project-overview.component.html',
  styleUrl: './project-overview.component.scss',
})
export class ProjectOverviewComponent
  extends PageLayoutBaseComponent
  implements OnInit, AfterViewInit
{
  pdfDocuments: PDFDocuments[] = [];

  constructor(
    protected override appService: AppService,
    private adobePdfService: AdobePdfService
  ) {
    super(appService);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.pdfDocuments = [
      {
        thumbnail:
          'https://vmr-cdn.tdotoutreach.com/content/thumbnails/ETSA-map_2025-0919.png',
        url: 'https://vmr-cdn.tdotoutreach.com/content/project-overview/ETSA-map_2025-0919.pdf',
        title: 'Project Map',
      },
      {
        thumbnail:
          'https://vmr-cdn.tdotoutreach.com/content/thumbnails/Whats-New-09-23-2025.jpg',
        url: 'https://vmr-cdn.tdotoutreach.com/content/project-overview/Whats-New-09-23-2025.pdf',
        title: "What's New",
      },
      {
        thumbnail:
          'https://vmr-cdn.tdotoutreach.com/content/thumbnails/Purpose-and-Need-09-23-2025.jpg',
        url: 'https://vmr-cdn.tdotoutreach.com/content/project-overview/Purpose-and-Need-09-23-2025.pdf',
        title: 'Purpose and Need',
      },
      {
        thumbnail:
          'https://vmr-cdn.tdotoutreach.com/content/thumbnails/TMA-09-23-2025.jpg',
        url: 'https://vmr-cdn.tdotoutreach.com/content/project-overview/TMA-09-23-2025.pdf',
        title: 'Transportation Modernization Act',
      },
      {
        thumbnail:
          'https://vmr-cdn.tdotoutreach.com/content/thumbnails/P3-09-23-2025.jpg',
        url: 'https://vmr-cdn.tdotoutreach.com/content/project-overview/P3-09-23-2025.pdf',
        title: 'Public Private Partnership (P3)',
      },
      {
        thumbnail:
          'https://vmr-cdn.tdotoutreach.com/content/thumbnails/Transit-Benefits-09-23-2025.jpg',
        url: 'https://vmr-cdn.tdotoutreach.com/content/project-overview/Transit-Benefits-09-23-2025.pdf',
        title: 'Transit Benefits',
      },
      {
        thumbnail:
          'https://vmr-cdn.tdotoutreach.com/content/thumbnails/Project-Schedule-09-23-2025.jpg',
        url: 'https://vmr-cdn.tdotoutreach.com/content/project-overview/Project-Schedule-09-23-2025.pdf',
        title: 'Project Schedule',
      },
    ];
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.adobePdfService.embedMultiplePdfs(this.pdfDocuments);
    }, 100);
  }
}
